import styled from "styled-components";


export const Container = styled.section`
  margin-top: 15rem;
  position: relative;
  
  /* Background effects */
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 60%;
    height: 100%;
    background: radial-gradient(circle, rgba(99, 102, 241, 0.1) 0%, transparent 70%);
    filter: blur(60px);
    z-index: -1;
  }

  header{
    text-align: center;
    margin-bottom: 5rem;
    position: relative;
    
    h2{
      font-size: clamp(3.5rem, 5vw, 5rem);
      font-weight: 800;
      background: var(--gradient-primary);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      margin-bottom: 2rem;
      position: relative;
      display: inline-block;
      
      /* Animated underline */
      &::after {
        content: '';
        position: absolute;
        bottom: -1rem;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 4px;
        background: var(--gradient-accent);
        border-radius: 2px;
        animation: expandLine 1.5s ease-out forwards;
      }
    }
    
    @keyframes expandLine {
      to {
        width: 120px;
      }
    }
    
    p{
      font-size: 1.8rem;
      font-weight: 600;
      margin: 1rem 0;
      position: relative;
      
      &:first-of-type {
        background: linear-gradient(135deg, #10b981, #06b6d4);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
      
      &:last-of-type {
        color: var(--primary);
        animation: pulse 2s ease-in-out infinite;
      }
    }
    
    @keyframes pulse {
      0%, 100% {
        opacity: 1;
        transform: scale(1);
      }
      50% {
        opacity: 0.8;
        transform: scale(1.02);
      }
    }
  }

  .contacts{
    display: flex;
    align-items: stretch;
    justify-content: center;
    gap: 3rem;
    place-items: center;
    margin-top: 3rem;
    padding: 0 2rem;
    
    div{
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      max-width: 35rem;
      gap: 2rem;
      padding: 2.5rem 3.5rem;
      border-radius: 2rem;
      transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      perspective: 1000px;
      overflow: hidden;
      
      /* Glassmorphism background */
      background: linear-gradient(135deg, 
        rgba(16, 185, 129, 0.15) 0%, 
        rgba(6, 182, 212, 0.15) 100%
      );
      backdrop-filter: blur(15px);
      border: 2px solid rgba(16, 185, 129, 0.3);
      box-shadow: 0 8px 32px rgba(16, 185, 129, 0.2);
      
      /* Animated gradient border */
      &::before {
        content: '';
        position: absolute;
        inset: -2px;
        border-radius: 2rem;
        padding: 2px;
        background: linear-gradient(135deg, #10b981, #06b6d4, #8b5cf6);
        background-size: 200% 200%;
        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        opacity: 0;
        transition: opacity 0.5s ease;
        animation: gradientShift 3s ease infinite;
      }
      
      /* Glow effect */
      &::after {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 2rem;
        background: linear-gradient(135deg, #10b981, #06b6d4);
        opacity: 0;
        filter: blur(30px);
        transition: opacity 0.5s ease;
        z-index: -1;
      }
      
      @keyframes gradientShift {
        0%, 100% {
          background-position: 0% 50%;
        }
        50% {
          background-position: 100% 50%;
        }
      }
      
      /* Icon container */
      & > a:first-child {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 6rem;
        height: 6rem;
        border-radius: 1.5rem;
        background: linear-gradient(135deg, #10b981, #06b6d4);
        box-shadow: 0 8px 24px rgba(16, 185, 129, 0.4);
        transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        transform-style: preserve-3d;
        
        &::before {
          content: '';
          position: absolute;
          inset: -4px;
          border-radius: 1.5rem;
          background: inherit;
          filter: blur(12px);
          opacity: 0;
          transition: opacity 0.5s ease;
          z-index: -1;
        }
      }
      
      img{
        width: 3.5rem;
        height: 3.5rem;
        filter: brightness(0) invert(1) drop-shadow(0 2px 8px rgba(255, 255, 255, 0.3));
        transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      }
      
      & > a:last-child {
        color: #fff;
        font-weight: 600;
        font-size: 1.7rem;
        letter-spacing: 0.05em;
        text-decoration: none;
        position: relative;
        transition: all 0.3s ease;
        
        &::after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 0;
          height: 2px;
          background: var(--gradient-primary);
          transition: width 0.4s ease;
        }
      }
      
      /* Hover effects */
      &:hover{
        transform: translateY(-12px) scale(1.03);
        border-color: var(--primary);
        box-shadow: 0 20px 60px rgba(99, 102, 241, 0.4);
        
        &::before {
          opacity: 1;
        }
        
        &::after {
          opacity: 0.6;
        }
        
        & > a:first-child {
          transform: rotateY(15deg) rotateX(-10deg) scale(1.1);
          box-shadow: 0 12px 40px rgba(99, 102, 241, 0.6);
          
          &::before {
            opacity: 0.8;
          }
        }
        
        img {
          transform: scale(1.15) rotateZ(5deg);
          filter: brightness(0) invert(1) drop-shadow(0 4px 16px rgba(255, 255, 255, 0.6));
        }
        
        & > a:last-child {
          color: var(--primary);
          transform: translateX(5px);
          
          &::after {
            width: 100%;
          }
        }
      }
      
      /* Active state */
      &:active {
        transform: translateY(-8px) scale(1.01);
      }
      
      /* Second contact (phone) - Different color */
      &:nth-child(2) {
        background: linear-gradient(135deg, 
          rgba(236, 72, 153, 0.15) 0%, 
          rgba(139, 92, 246, 0.15) 100%
        );
        border-color: rgba(236, 72, 153, 0.3);
        box-shadow: 0 8px 32px rgba(236, 72, 153, 0.2);
        
        & > a:first-child {
          background: linear-gradient(135deg, #ec4899, #8b5cf6);
          box-shadow: 0 8px 24px rgba(236, 72, 153, 0.4);
        }
        
        &:hover {
          box-shadow: 0 20px 60px rgba(236, 72, 153, 0.4);
          
          & > a:first-child {
            box-shadow: 0 12px 40px rgba(236, 72, 153, 0.6);
          }
        }
      }
    }
  }

  /* Tablet */
  @media(max-width: 960px){
    margin-top: 12rem;
    
    header {
      h2 {
        font-size: 3.5rem;
      }
      
      p {
        font-size: 1.6rem;
      }
    }
    
    .contacts{
      flex-direction: column;
      gap: 2.5rem;
      
      div{
        width: 100%;
        max-width: 50rem;
      }
    }
  }
  
  /* Mobile */
  @media(max-width: 600px){
    margin-top: 10rem;
    
    header {
      margin-bottom: 4rem;
      
      h2 {
        font-size: 3rem;
        
        &::after {
          width: 80px !important;
        }
      }
      
      p {
        font-size: 1.5rem;
        padding: 0 2rem;
      }
    }
    
    .contacts{
      padding: 0 1rem;
      gap: 2rem;
      
      div{
        flex-direction: column;
        padding: 2.5rem 2rem;
        gap: 1.5rem;
        
        & > a:first-child {
          width: 5.5rem;
          height: 5.5rem;
        }
        
        img {
          width: 3rem;
          height: 3rem;
        }
        
        & > a:last-child {
          font-size: 1.5rem;
          text-align: center;
        }
        
        &:hover {
          transform: translateY(-8px) scale(1.02);
        }
      }
    }
  }
  
  /* Small mobile */
  @media(max-width: 400px){
    header {
      h2 {
        font-size: 2.5rem;
      }
      
      p {
        font-size: 1.3rem;
      }
    }
    
    .contacts {
      div {
        padding: 2rem 1.5rem;
        
        & > a:first-child {
          width: 5rem;
          height: 5rem;
        }
        
        img {
          width: 2.5rem;
          height: 2.5rem;
        }
        
        & > a:last-child {
          font-size: 1.3rem;
        }
      }
    }
  }
`
/* old one - 2/1/2023 - 
@media(max-width: 960px){
    .contacts{
      flex-direction: column;
      div{
        width: 100%;
        flex-direction: column;
      }
    }

*/

